import React from "react";
import { site } from "@/config/site";

// Logo officiel NEKASSUR (PNG transparent). Ratio d'origine préservé (object-contain, height auto).
export default function BrandLogo({ className = "h-10 w-auto" }) {
  return (
    <img
      src={site.media.logoUrl}
      alt=""
      width={2011}
      height={467}
      draggable="false"
      className={`${className} object-contain select-none`}
    />
  );
}
